export const digitalInformationArray = [
  {
    title: "2023 was District’s deadliest year in more than two decades",
    description: "",
    awards: "Award of Excellence from SND for Regional/Local page design",
    url: "https://www.washingtonpost.com/dc-md-va/interactive/2024/dc-crime-homicide-victims-shooting-violence/",
    video: {
      src: "/projects/digital/dc-homicide.mp4",
      alt: "",
    },
  },
  {
    title: "Enduring images of 2024",
    description: "",
    awards: "",
    url: "https://www.washingtonpost.com/nation/interactive/2024/pictures-of-the-year-2024/",
    video: {
      src: "/projects/digital/yip.mp4",
      alt: "",
    },
  },
  {
    title: "Stress is weathering our bodies from the inside out",
    description: "",
    awards: "",
    url: "https://www.washingtonpost.com/health/interactive/2023/stress-chronic-illness-aging/",
    video: {
      src: "/projects/digital/stress.mp4",
      alt: "",
    },
  },
  {
    title: "The Ukrainian children killed in Russian strikes this year",
    description: "",
    awards: "",
    url: "https://www.washingtonpost.com/world/interactive/2025/ukraine-russia-children-killed-war/",
    video: {
      src: "/projects/digital/ukrainechildren.mp4",
      alt: "",
    },
  },
  {
    title: "Ukrainians reflect on a year of loss, resilience and fear.",
    description: "",
    awards: "",
    url: "https://www.washingtonpost.com/world/interactive/2023/ukraine-russia-anniversary-portraits/",
    video: {
      src: "/projects/digital/ukraine.mp4",
      alt: "",
    },
  },
];
